<template>
    <div class="row">
        <h5 class="col-sm-4 col-md-4 text-grey">{{ __('Shipments') }}<span v-if="total > 0"> {{ total }} brutto/t.</span></h5>
       
        <div class="col-sm-4 col-md-4">
            <select @change="filterChart" class="form-control custom-select" v-model="month.value">
                <option
                    :key="index"
                    :value="month.value"
                    v-for="(month, index) in months"
                >
                    {{ month.text }}
                </option>
            </select>
        </div>

        <div class="col-sm-4 col-md-4">
            <select @change="filterChart" class="form-control custom-select" v-model="year.value">
                <option
                    :key="index"
                    :value="year.value"
                    v-for="(year, index) in years"
                >
                    {{ year.text }}
                </option>
            </select>
        </div>

        <template>
            <div class="col-sm-12 col-md-12 pt-3">
                <BarCharts
                    :chart-data="dataCollectionLoads"
                    :datasets="chartData"
                    :labels="labels"
                    v-if="loaded"
                ></BarCharts>
            </div>
        </template>
    </div>
</template>

<script>
import { __ } from '../../translations/localization'
import _ from 'lodash'

export default {
  name: 'LoadsCharts',

  async mounted () {
    this.loaded = false
    try {
      this.$api.dashboard.charts().then((res) => {
        this.chartData = this.mapChartData(res)
        this.loaded = true
      })
    } catch (e) {
      return false
    }
  },

  data () {
    return {
      month: {
        value: new Date().getMonth()+1
      },
      year: {
        value: new Date().getFullYear()
      },
      total:0,
      loaded: false,
      chartData: [],
      labels: [''],
      months: [
        {
          value: '1',
          text: __('January')
        },
        {
          value: '2',
          text: __('February')
        },
        {
          value: '3',
          text: __('March')
        },
        {
          value: '4',
          text: __('April')
        },
        {
          value: '5',
          text: __('May')
        },
        {
          value: '6',
          text: __('June')
        },
        {
          value: '7',
          text: __('July')
        },
        {
          value: '8',
          text: __('August')
        },
        {
          value: '9',
          text: __('September')
        },
        {
          value: '10',
          text: __('October')
        },
        {
          value: '11',
          text: __('November')
        },
        {
          value: '12',
          text: __('December')
        }
      ],
      years: [
        {
          value: new Date().getFullYear(),
          text: new Date().getFullYear()
        },
        {
          value: new Date().getFullYear() - 1,
          text: new Date().getFullYear() - 1
        },
        {
          value: new Date().getFullYear() - 2,
          text: new Date().getFullYear() - 2
        }
      ],
      dataCollectionLoads: null
    }
  },

  methods: {
    
  
    mapChartData (res) {
      return _.map(res.shipments, function (element) {
        return _.extend({}, element, { backgroundColor:  `rgb(${Math.floor(Math.random() * (235 - 52 + 1) + 52)}, ${Math.floor(Math.random() * (235 - 52 + 1) + 52)}, ${Math.floor(Math.random() * (235 - 52 + 1) + 52)})`
         })
      })
    },

    async filterChart () {
      this.loaded = false
      try {
        this.$api.dashboard.charts({ month: this.month.value, year: this.year.value }).then((res) => {
          this.chartData = this.mapChartData(res)
          this.total=res.total
          this.$emit('chartFilter', res)
          this.loaded = true
        })
      } catch (e) {
        return false
      }
    }
  }
}
</script>

